import React, { useEffect, useState, useRef } from 'react';
import {
    Form,
    Input,
    InputNumber,
    Cascader,
    Select,
    Row,
    Col,
    Checkbox,
    Button,
    AutoComplete,
    message,
    Alert
} from 'antd';
import cloneDeep from 'lodash/cloneDeep';

import icon_add_conditional from 'images/icon_add_conditional.svg';
import icon_arrow_down_light from 'images/icon_arrow_down_light.svg';
import icon_less_than from 'images/function/icon_less_than.svg';
import icon_great_than from 'images/function/icon_great_than.svg';
import icon_equal_to from 'images/function/icon_equal_to.svg';
import icon_not_equal_to from 'images/function/icon_not_equal_to.svg';
import icon_less_than_or_equal_to from 'images/function/icon_less_than_or_equal_to.svg';
import icon_greater_than_or_equal_to from 'images/function/icon_greater_than_or_equal_to.svg';
import icon_contains from 'images/function/icon_contains.svg';
import icon_is_empty from 'images/function/icon_is_empty.svg';
import icon_subtraction_conditional from 'images/icon_subtraction_conditional.svg';
import keyBy from 'lodash/keyBy';
import { PlusIcon } from 'images/PlusIcon';
import { updateOrCreateColumn } from 'services/project';
import { useOnClickOutside } from 'hooks/useOnClickOutside';

const TransformConditional = (props) => {
    const ref = useRef();
    const [addButtonsVisible, setAddButtonsVisible] = useState(true);
    const [listsObject, setListsObject] = useState();
    const [loadingSpinner, setLoadingSpinner] = useState(false);

    // console.log(`ref`, ref);
    useOnClickOutside(ref, () => setShowListBox(0));
    // if (ref.current.classList.contains('select-box-grey')) {
    //     console.log(`on`);
    // } else {
    //     console.log(`of`);
    // }

    // conditionalItems={conditionalItems}
    // setConditionalItems={setConditionalItems}

    // const [showListBoxGreyTypeA, setShowListBoxGreyTypeA] = useState();
    // const [showListBoxGreyVarA, setShowListBoxGreyVarA] = useState();
    // const [showListBoxFunction, setShowListBoxFunction] = useState();
    // const [showListBoxGreyTypeB, setShowListBoxGreyTypeB] = useState();
    // const [showListBoxGreyVarB, setShowListBoxGreyVarB] = useState();

    const [showListBox, setShowListBox] = useState(0);
    const [checkEmptyFields, setCheckEmptyFields] = useState(false);

    // useEffect(() => {}, [showListBoxGreyTypeA]);

    let functionTable = [
        { name: 'Less than', src: icon_less_than, mark: '<' },
        { name: 'Greater than', src: icon_great_than, mark: '>' },
        { name: 'Equal to', src: icon_equal_to, mark: '=' },
        { name: 'Not equal to', src: icon_not_equal_to, mark: '!=' },
        {
            name: 'Less than or equal to',
            src: icon_less_than_or_equal_to,
            mark: '<='
        },
        {
            name: 'Greater than or equal to',
            src: icon_greater_than_or_equal_to,
            mark: '>='
        },
        { name: 'Contains', src: icon_contains, mark: 'IN' },
        { name: 'Is empty', src: icon_is_empty, mark: '0' }
    ];
    const functionTableByMark = keyBy(functionTable, 'mark');

    const conditionDict = { if: 'If', else_if: 'Else If', else: 'Else' };

    let copyListsObject = cloneDeep(props.conditionalItems);

    // console.log(`copyListsObject: ${JSON.stringify(copyListsObject)}`)

    const tableColumnByIndex = keyBy(props.tableColumn, 'dataIndex');

    let maxId = 0;

    if (copyListsObject.length) {
        let itemIds = copyListsObject.map((item) => {
            return item.id;
        });

        maxId = Math.max.apply(Math, itemIds);
    }

    const handleAddElseIf = () => {
        copyListsObject.push({
            id: maxId + 1,
            type: 'else_if',
            condition: [
                {
                    var_a_type: 'Column',
                    var_a: '',
                    var_b_type: 'Value',
                    var_b: '',
                    function: '',
                    and_or: ''
                }
            ],
            then_type: 'Value',
            then: ''
        });
        props.setConditionalItems(copyListsObject);
    };

    const handleAddElse = () => {
        copyListsObject.push({
            id: maxId + 1,
            type: 'else',
            condition: [
                {
                    var_a_type: '',
                    var_a: '',
                    var_b_type: '',
                    var_b: '',
                    function: '',
                    and_or: ''
                }
            ],
            then_type: 'Value',
            then: ''
        });

        props.setConditionalItems(copyListsObject);
        setAddButtonsVisible(false);
    };

    const handleAddAndOr = (dataIndex, logical) => {
        let copyState = cloneDeep(props.conditionalItems);

        // console.log(`add And/OR`, logical);
        for (let i in copyState) {
            if (copyState[i].id == dataIndex) {
                copyState[i].condition.push({
                    var_a_type: 'Column',
                    var_a: '',
                    var_b_type: 'Value',
                    var_b: '',
                    function: '',
                    and_or: logical
                });
            }
        }

        props.setConditionalItems(copyState);
    };

    const handleRemoveAndOr = (dataIndex) => {
        let copyListsObject = cloneDeep(props.conditionalItems);

        let indexToRemove = copyListsObject.findIndex((object) => {
            return object.id === dataIndex;
        });

        // console.log(`indexToRemove`, indexToRemove);

        // console.log(`dataIndex to remove`, dataIndex);
        copyListsObject[indexToRemove].condition.pop();
        props.setConditionalItems(copyListsObject);
    };

    const handleBtnClearAll = () => {
        copyListsObject = [];
        copyListsObject.push({
            id: 1,
            type: 'if',
            condition: [
                {
                    var_a_type: 'Column',
                    var_a: '',
                    var_b_type: 'Value',
                    var_b: '',
                    function: '',
                    and_or: ''
                }
            ],
            then_type: 'Value',
            then: ''
        });
        props.setConditionalItems(copyListsObject);
        props.setConditionalName('Condition name');

        setLoadingSpinner(false);
        props.setConditionalTransform(null);
        props.setColumnDbId(null);

        // setCheckEmptyFields(false);
    };

    // console.log(`props.conditionalItems`, props.conditionalItems);

    const handleBtnCreate = (columnId) => {
        setLoadingSpinner(true);
        // console.log(`columnId`, columnId);
        // console.log(`dataToSend`, props.conditionalItems);
        let currentProject = localStorage.getItem('activeProject');
        if (
            props.conditionalItems[0].condition[0].var_a === '' ||
            (props.conditionalItems[0].condition[0].var_b === '' &&
                props.conditionalItems[0].condition[0].function != '0') ||
            props.conditionalItems[0].condition[0].function === ''
        ) {
            message.error('Please select all fields');
            setLoadingSpinner(false);
        } else {
            const data = {
                project: currentProject,
                conditional_transform: props.conditionalItems,
                trans_type: 'conditional',
                name: props.conditionalName
            };

            updateOrCreateColumn(data, columnId).then((res) => {
                if (res.status === 200) {
                    props.setColumnDbId(res.id);
                    setLoadingSpinner(false);
                    message.success('Updated');
                } else if (res.status === 201) {
                    setLoadingSpinner(false);
                    message.success('Created');
                    // Add here scrollBy to the right
                    // console.log(`res.status:`, res.status);
                } else if (res.status === 500) {
                    setLoadingSpinner(false);
                    message.error('Something went wrong, code 500');
                    // console.log(`res.status:`, res.status);
                } else {
                    setLoadingSpinner(false);
                    message.error('Something went wrong, code 500');
                }
            });
            setCheckEmptyFields(true);
            props.setConditionalItems([{"id":1,"type":"if","condition":[{"var_a_type":"Column","var_a":"","var_b_type":"Value","var_b":"","function":"","and_or":""}],"then_type":"Value","then":""}])
            setTimeout(()=>{
                props.setConditionalName('Condition name')
                props.setColumnDbId(null);
                props.setRerenderTable(!props.rerenderTable);
            },1500)
        }
    };

    const handleRemoveElse = (deleteId) => {
        let findIndexToDelete = copyListsObject.findIndex(
            (item) => item.id === deleteId
        );

        copyListsObject.splice(findIndexToDelete, 1);

        props.setConditionalItems(copyListsObject);
    };

    const handleChangeState = (
        dataIndex,
        subConditionId,
        dataType,
        name,
        value
    ) => {
        let copyState = cloneDeep(props.conditionalItems);

        for (let i in copyState) {
            if (copyState[i].id == dataIndex) {
                if (dataType == 'then') {
                    if (name) {
                        copyState[i][dataType + '_type'] = name;
                    }
                    copyState[i][dataType] = value;
                } else {
                    if (name) {
                        copyState[i].condition[subConditionId][
                            dataType + '_type'
                        ] = name;
                    }
                    copyState[i].condition[subConditionId][dataType] = value;
                }
            }
        }

        props.setConditionalItems(copyState);
    };

    const handleChangeStateInput = (
        dataIndex,
        subConditionId,
        dataType,
        value
    ) => {
        let copyState = cloneDeep(props.conditionalItems);

        for (let i in copyState) {
            if (copyState[i].id == dataIndex) {
                if (dataType === 'var_a' || dataType === 'var_b') {
                    copyState[i].condition[subConditionId][dataType] = value;
                } else {
                    copyState[i].then = value;
                }
            }
        }

        props.setConditionalItems(copyState);
    };

    const handleShowListBox = (boxId) => {
        // console.log(`boxIdToOPEN`, boxId);
        if (showListBox === boxId) {
            setShowListBox(0);
        } else {
            setShowListBox(boxId);
        }
    };

    // const closeDropdown = (e) => {
    //     if (showListBox !== 0) {
    //         // setShowListBox(0);
    //     }
    //     console.log(`typeOf `, typeof showListBox);
    // };
    // document.body.addEventListener('click', closeDropdown);

    const tableColumnsDisplay = (
        tableColumn,
        conditionId,
        subConditionId,
        dataType
    ) => {
        let columnList = [];
        for (let columnIndex in tableColumn) {
            columnList.push(
                <li
                    key={columnIndex + dataType + conditionId}
                    onClick={() => {
                        handleChangeState(
                            conditionId,
                            subConditionId,
                            dataType,
                            '',
                            tableColumn[columnIndex].dataIndex
                        );
                    }}
                >
                    {tableColumn[columnIndex].columnName}
                </li>
            );
        }

        return columnList;
    };

    const functionsListDisplay = (
        functionTable,
        conditionId,
        subConditionId
    ) => {
        let functionList = [];
        for (let i in functionTable) {
            functionList.push(
                <li
                    key={i + 'f' + conditionId}
                    onClick={() => {
                        handleChangeState(
                            conditionId,
                            subConditionId,
                            `function`,
                            false,
                            functionTable[i].mark
                        );
                    }}
                >
                    <div>{functionTable[i].name}</div>
                    <div>
                        <img src={functionTable[i].src} />
                    </div>
                </li>
            );
        }

        return functionList;
    };

    let itemListsObject = props.conditionalItems.map((item) => {
        let conditionalName = conditionDict[item.type];

        let availableColumnList = tableColumnsDisplay(
            props.tableColumn,
            item.id,
            0,
            'var_a'
        );

        let availableColumnListB = tableColumnsDisplay(
            props.tableColumn,
            item.id,
            0,
            'var_b'
        );

        let availableColumnListThen = tableColumnsDisplay(
            props.tableColumn,
            item.id,
            0,
            'then'
        );

        let availableFunctionList = functionsListDisplay(
            functionTable,
            item.id,
            0
        );

        let availableColumnList1 = tableColumnsDisplay(
            props.tableColumn,
            item.id,
            1,
            'var_a'
        );

        let availableColumnListB1 = tableColumnsDisplay(
            props.tableColumn,
            item.id,
            1,
            'var_b'
        );

        let availableFunctionList1 = functionsListDisplay(
            functionTable,
            item.id,
            1
        );

        return (
            // <div key={item.id} ref={ref}>
                <div key={item.id} >
                {/* {item.id} */}
                <div>
                    {item.type === 'if' ? (
                        <div className="condition-name">If</div>
                    ) : (
                        <div className="condition-name-else">
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center'
                                }}
                            >
                                <img
                                    onClick={() => {
                                        handleRemoveElse(item.id);
                                    }}
                                    style={{ marginRight: '6px' }}
                                    src={icon_subtraction_conditional}
                                />
                                {conditionalName}
                            </div>
                        </div>
                    )}
                </div>

                {item.type === 'if' || item.type === 'else_if' ? (
                    <div className="transform-conditional">
                        <div className="transform-conditional-card">
                            <div>
                                <div
                                    onClick={(e) => {
                                        handleShowListBox(`${item.id}_1`);
                                    }}
                                    className="select-box-grey"
                                >
                                    <div className="title-var-left">
                                        {item.condition[0].var_a_type}
                                    </div>
                                    <div>
                                        <img
                                            className="icon-arrow-down"
                                            src={icon_arrow_down_light}
                                        />
                                    </div>
                                </div>
                                <div
                                    className={
                                        showListBox === `${item.id}_1`
                                            ? 'select-list-box-grey'
                                            : 'd-none'
                                    }
                                >
                                    <ul
                                        onClick={() => {
                                            handleShowListBox(`${item.id}_1`);
                                        }}
                                    >
                                        <li
                                            onClick={() =>
                                                handleChangeState(
                                                    item.id,
                                                    0,
                                                    `var_a`,
                                                    'Column',
                                                    ''
                                                )
                                            }
                                        >
                                            Column
                                        </li>
                                        <li
                                            onClick={() =>
                                                handleChangeState(
                                                    item.id,
                                                    0,
                                                    `var_a`,
                                                    'Value',
                                                    ''
                                                )
                                            }
                                        >
                                            Value
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            {item.condition[0].var_a_type === 'Column' ? (
                                <>
                                    <div
                                        onClick={() => {
                                            handleShowListBox(`${item.id}_2`);
                                        }}
                                        className={`select-box-white`}
                                        // className={`select-box-white ${
                                        //     checkEmptyFields &&
                                        //     item.condition[0].var_a === ''
                                        //         ? 'border-box-red'
                                        //         : ''
                                        // }`}
                                    >
                                        <div className="title-var-right">
                                            {item.condition[0].var_a
                                                ? tableColumnByIndex[
                                                      item.condition[0].var_a
                                                  ].columnName
                                                : 'Select Column'}
                                        </div>
                                        <div>
                                            <img
                                                className="icon-arrow-down"
                                                src={icon_arrow_down_light}
                                            />
                                        </div>
                                    </div>
                                    <div
                                        className={
                                            showListBox === `${item.id}_2`
                                                ? 'select-list-box-white'
                                                : 'd-none'
                                        }
                                    >
                                        <ul
                                            onClick={() => {
                                                handleShowListBox(
                                                    `${item.id}_2`
                                                );
                                            }}
                                        >
                                            {availableColumnList}
                                        </ul>
                                    </div>
                                </>
                            ) : (
                                <input
                                    className="input-box-white"
                                    placeholder="Type here"
                                    onChange={(e) =>
                                        handleChangeStateInput(
                                            item.id,
                                            0,
                                            `var_a`,
                                            e.target.value
                                        )
                                    }
                                    value={item.condition[0].var_a}
                                />
                            )}
                        </div>

                        <div className="transform-conditional-card">
                            <div>
                                <div className="select-box-grey">
                                    <div className="title-var-left">
                                        Function
                                    </div>
                                    <div>
                                        {/* <img
                                        className="icon-arrow-down"
                                        src={icon_arrow_down_light}
                                    /> */}
                                    </div>
                                </div>
                                {/* <div className="select-list-box-grey">
                                <ul>
                                    <li></li>
                                </ul>
                            </div> */}
                            </div>
                            <div
                                onClick={() => {
                                    handleShowListBox(`${item.id}_3`);
                                }}
                                className="select-box-white"
                            >
                                <div className="title-var-right">
                                    {item.condition[0].function
                                        ? functionTableByMark[
                                              item.condition[0].function
                                          ].name
                                        : 'Select Condition'}
                                </div>
                                <div>
                                    <img
                                        className="icon-arrow-down"
                                        src={icon_arrow_down_light}
                                    />
                                </div>
                            </div>
                            <div
                                className={
                                    showListBox === `${item.id}_3`
                                        ? 'select-list-box-function-white'
                                        : 'd-none'
                                }
                            >
                                <ul
                                    onClick={() => {
                                        handleShowListBox(`${item.id}_3`);
                                    }}
                                >
                                    {availableFunctionList}
                                </ul>
                            </div>
                        </div>
                        {item.condition[0].function != '0' ? (
                            <div className="transform-conditional-card">
                                <div>
                                    <div
                                        onClick={() => {
                                            handleShowListBox(`${item.id}_4`);
                                        }}
                                        className="select-box-grey"
                                    >
                                        <div className="title-var-left">
                                            {item.condition[0].var_b_type}
                                        </div>
                                        <div>
                                            <img
                                                className="icon-arrow-down"
                                                src={icon_arrow_down_light}
                                            />
                                        </div>
                                    </div>
                                    <div
                                        className={
                                            showListBox === `${item.id}_4`
                                                ? 'select-list-box-grey'
                                                : 'd-none'
                                        }
                                    >
                                        <ul
                                            onClick={() => {
                                                handleShowListBox(
                                                    `${item.id}_4`
                                                );
                                            }}
                                        >
                                            <li
                                                onClick={() =>
                                                    handleChangeState(
                                                        item.id,
                                                        0,
                                                        `var_b`,
                                                        'Column',
                                                        ''
                                                    )
                                                }
                                            >
                                                Column
                                            </li>
                                            <li
                                                onClick={() =>
                                                    handleChangeState(
                                                        item.id,
                                                        0,
                                                        `var_b`,
                                                        'Value',
                                                        ''
                                                    )
                                                }
                                            >
                                                Value
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                {item.condition[0].var_b_type === 'Column' ? (
                                    <>
                                        <div
                                            onClick={() => {
                                                handleShowListBox(
                                                    `${item.id}_5`
                                                );
                                            }}
                                            className="select-box-white"
                                        >
                                            <div className="title-var-right">
                                                {item.condition[0].var_b
                                                    ? tableColumnByIndex[
                                                          item.condition[0]
                                                              .var_b
                                                      ].columnName
                                                    : 'Select Column'}
                                            </div>
                                            <div>
                                                <img
                                                    className="icon-arrow-down"
                                                    src={icon_arrow_down_light}
                                                />
                                            </div>
                                        </div>
                                        <div
                                            className={
                                                showListBox === `${item.id}_5`
                                                    ? 'select-list-box-white'
                                                    : 'd-none'
                                            }
                                        >
                                            <ul
                                                onClick={() => {
                                                    handleShowListBox(
                                                        `${item.id}_5`
                                                    );
                                                }}
                                            >
                                                {availableColumnListB}
                                            </ul>
                                        </div>
                                    </>
                                ) : (
                                    <input
                                        className="input-box-white"
                                        placeholder="Type here"
                                        onChange={(e) =>
                                            handleChangeStateInput(
                                                item.id,
                                                0,
                                                `var_b`,
                                                e.target.value
                                            )
                                        }
                                        value={item.condition[0].var_b}
                                    />
                                )}
                            </div>
                        ) : null}

                        {/* AND OR */}
                        {item.condition.length > 1 ? null : (
                            <div className="add-condition-container">
                                <div
                                    className="transform-conditional-card-add"
                                    onClick={() => {
                                        handleAddAndOr(item.id, 'and');
                                    }}
                                >
                                    {/* <img src={icon_add_conditional} /> */}
                                    <PlusIcon />
                                    <div className="add-condition">And</div>
                                </div>
                                <div
                                    className="transform-conditional-card-add"
                                    onClick={() => {
                                        handleAddAndOr(item.id, 'or');
                                    }}
                                >
                                    <img src={icon_add_conditional} />
                                    <div className="add-condition">Or</div>
                                </div>
                            </div>
                        )}

                        {/* AND OR END*/}

                        {item.condition.length > 1 ? (
                            <>
                                {item.condition[1].and_or === 'and' ? (
                                    <div className="add-condition-container">
                                        <div
                                            className="transform-conditional-card-add"
                                            onClick={() => {
                                                handleRemoveAndOr(
                                                    item.id,
                                                    'and'
                                                );
                                            }}
                                        >
                                            <img
                                                src={
                                                    icon_subtraction_conditional
                                                }
                                            />
                                            <div className="add-condition">
                                                And
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="add-condition-container">
                                        <div
                                            className="transform-conditional-card-add"
                                            onClick={() => {
                                                handleRemoveAndOr(
                                                    item.id,
                                                    'or'
                                                );
                                            }}
                                        >
                                            <img
                                                src={
                                                    icon_subtraction_conditional
                                                }
                                            />
                                            <div className="add-condition">
                                                Or
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <div className="transform-conditional-card">
                                    <div>
                                        <div
                                            onClick={() => {
                                                handleShowListBox(
                                                    `${item.id}_11`
                                                );
                                            }}
                                            className="select-box-grey"
                                        >
                                            <div className="title-var-left">
                                                {item.condition[1].var_a_type}
                                            </div>
                                            <div>
                                                <img
                                                    className="icon-arrow-down"
                                                    src={icon_arrow_down_light}
                                                />
                                            </div>
                                        </div>
                                        <div
                                            className={
                                                showListBox === `${item.id}_11`
                                                    ? 'select-list-box-grey'
                                                    : 'd-none'
                                            }
                                        >
                                            <ul
                                                onClick={() => {
                                                    handleShowListBox(
                                                        `${item.id}_11`
                                                    );
                                                }}
                                            >
                                                <li
                                                    onClick={() =>
                                                        handleChangeState(
                                                            item.id,
                                                            1,
                                                            `var_a`,
                                                            'Column',
                                                            ''
                                                        )
                                                    }
                                                >
                                                    Column
                                                </li>
                                                <li
                                                    onClick={() =>
                                                        handleChangeState(
                                                            item.id,
                                                            1,
                                                            `var_a`,
                                                            'Value',
                                                            ''
                                                        )
                                                    }
                                                >
                                                    Value
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    {item.condition[1].var_a_type ===
                                    'Column' ? (
                                        <>
                                            <div
                                                onClick={() => {
                                                    handleShowListBox(
                                                        `${item.id}_12`
                                                    );
                                                }}
                                                className={`select-box-white `}
                                            >
                                                <div className="title-var-right">
                                                    {item.condition[1].var_a
                                                        ? tableColumnByIndex[
                                                              item.condition[1]
                                                                  .var_a
                                                          ].columnName
                                                        : 'Select Column'}
                                                </div>
                                                <div>
                                                    <img
                                                        className="icon-arrow-down"
                                                        src={
                                                            icon_arrow_down_light
                                                        }
                                                    />
                                                </div>
                                            </div>
                                            <div
                                                className={
                                                    showListBox ===
                                                    `${item.id}_12`
                                                        ? 'select-list-box-white'
                                                        : 'd-none'
                                                }
                                            >
                                                <ul
                                                    onClick={() => {
                                                        handleShowListBox(
                                                            `${item.id}_12`
                                                        );
                                                    }}
                                                >
                                                    {availableColumnList1}
                                                </ul>
                                            </div>
                                        </>
                                    ) : (
                                        <input
                                            className="input-box-white"
                                            placeholder="Type here"
                                            onChange={(e) =>
                                                handleChangeStateInput(
                                                    item.id,
                                                    1,
                                                    `var_a`,
                                                    e.target.value
                                                )
                                            }
                                            value={item.condition[1].var_a}
                                        />
                                    )}
                                </div>

                                <div className="transform-conditional-card">
                                    <div>
                                        <div className="select-box-grey">
                                            <div className="title-var-left">
                                                Function
                                            </div>
                                            <div>
                                                {/* <img
                                        className="icon-arrow-down"
                                        src={icon_arrow_down_light}
                                    /> */}
                                            </div>
                                        </div>
                                        {/* <div className="select-list-box-grey">
                                <ul>
                                    <li></li>
                                </ul>
                            </div> */}
                                    </div>
                                    <div
                                        onClick={() => {
                                            handleShowListBox(`${item.id}_13`);
                                        }}
                                        className="select-box-white"
                                    >
                                        <div className="title-var-right">
                                            {item.condition[1].function
                                                ? functionTableByMark[
                                                      item.condition[1].function
                                                  ].name
                                                : 'Select Condition'}
                                        </div>
                                        <div>
                                            <img
                                                className="icon-arrow-down"
                                                src={icon_arrow_down_light}
                                            />
                                        </div>
                                    </div>
                                    <div
                                        className={
                                            showListBox === `${item.id}_13`
                                                ? 'select-list-box-function-white'
                                                : 'd-none'
                                        }
                                    >
                                        <ul
                                            onClick={() => {
                                                handleShowListBox(
                                                    `${item.id}_13`
                                                );
                                            }}
                                        >
                                            {availableFunctionList1}
                                        </ul>
                                    </div>
                                </div>

                                <div className="transform-conditional-card">
                                    <div>
                                        <div
                                            onClick={() => {
                                                handleShowListBox(
                                                    `${item.id}_14`
                                                );
                                            }}
                                            className="select-box-grey"
                                        >
                                            <div className="title-var-left">
                                                {item.condition[1].var_b_type}
                                            </div>
                                            <div>
                                                <img
                                                    className="icon-arrow-down"
                                                    src={icon_arrow_down_light}
                                                />
                                            </div>
                                        </div>
                                        <div
                                            className={
                                                showListBox === `${item.id}_14`
                                                    ? 'select-list-box-grey'
                                                    : 'd-none'
                                            }
                                        >
                                            <ul
                                                onClick={() => {
                                                    handleShowListBox(
                                                        `${item.id}_14`
                                                    );
                                                }}
                                            >
                                                <li
                                                    onClick={() =>
                                                        handleChangeState(
                                                            item.id,
                                                            1,
                                                            `var_b`,
                                                            'Column',
                                                            ''
                                                        )
                                                    }
                                                >
                                                    Column
                                                </li>
                                                <li
                                                    onClick={() =>
                                                        handleChangeState(
                                                            item.id,
                                                            1,
                                                            `var_b`,
                                                            'Value',
                                                            ''
                                                        )
                                                    }
                                                >
                                                    Value
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    {item.condition[1].var_b_type ===
                                    'Column' ? (
                                        <>
                                            <div
                                                onClick={() => {
                                                    handleShowListBox(
                                                        `${item.id}_15`
                                                    );
                                                }}
                                                className="select-box-white"
                                            >
                                                <div className="title-var-right">
                                                    {item.condition[1].var_b
                                                        ? tableColumnByIndex[
                                                              item.condition[1]
                                                                  .var_b
                                                          ].columnName
                                                        : 'Select Column'}
                                                </div>
                                                <div>
                                                    <img
                                                        className="icon-arrow-down"
                                                        src={
                                                            icon_arrow_down_light
                                                        }
                                                    />
                                                </div>
                                            </div>
                                            <div
                                                className={
                                                    showListBox ===
                                                    `${item.id}_15`
                                                        ? 'select-list-box-white'
                                                        : 'd-none'
                                                }
                                            >
                                                <ul
                                                    onClick={() => {
                                                        handleShowListBox(
                                                            `${item.id}_15`
                                                        );
                                                    }}
                                                >
                                                    {availableColumnListB1}
                                                </ul>
                                            </div>
                                        </>
                                    ) : (
                                        <input
                                            className="input-box-white"
                                            placeholder="Type here"
                                            onChange={(e) =>
                                                handleChangeStateInput(
                                                    item.id,
                                                    1,
                                                    `var_b`,
                                                    e.target.value
                                                )
                                            }
                                            value={item.condition[1].var_b}
                                        />
                                    )}
                                </div>
                            </>
                        ) : null}

                        {/* END AND OR */}

                        <div className="condition-name">Then</div>
                        <div className="transform-conditional-card">
                            <div>
                                <div
                                    onClick={() => {
                                        handleShowListBox(`${item.id}_6`);
                                    }}
                                    className="select-box-grey"
                                >
                                    <div className="title-var-left">
                                        {item.then_type}
                                    </div>
                                    <div>
                                        <img
                                            className="icon-arrow-down"
                                            src={icon_arrow_down_light}
                                        />
                                    </div>
                                </div>
                                <div
                                    className={
                                        showListBox === `${item.id}_6`
                                            ? 'select-list-box-grey'
                                            : 'd-none'
                                    }
                                >
                                    <ul
                                        onClick={() => {
                                            handleShowListBox(`${item.id}_6`);
                                        }}
                                    >
                                        <li
                                            onClick={() =>
                                                handleChangeState(
                                                    item.id,
                                                    0,
                                                    `then`,
                                                    'Column',
                                                    ''
                                                )
                                            }
                                        >
                                            Column
                                        </li>
                                        <li
                                            onClick={() =>
                                                handleChangeState(
                                                    item.id,
                                                    0,
                                                    `then`,
                                                    'Value',
                                                    ''
                                                )
                                            }
                                        >
                                            Value
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            {item.then_type === 'Column' ? (
                                <>
                                    <div
                                        onClick={() => {
                                            handleShowListBox(`${item.id}_7`);
                                        }}
                                        className="select-box-white"
                                    >
                                        <div className="title-var-right">
                                            {item.then
                                                ? tableColumnByIndex[item.then]
                                                      .columnName
                                                : null}
                                        </div>
                                        <div>
                                            <img
                                                className="icon-arrow-down"
                                                src={icon_arrow_down_light}
                                            />
                                        </div>
                                    </div>
                                    <div
                                        className={
                                            showListBox === `${item.id}_7`
                                                ? 'select-list-box-white'
                                                : 'd-none'
                                        }
                                    >
                                        <ul
                                            onClick={() => {
                                                handleShowListBox(
                                                    `${item.id}_7`
                                                );
                                            }}
                                        >
                                            {availableColumnListThen}
                                        </ul>
                                    </div>
                                </>
                            ) : (
                                <input
                                    className="input-box-white"
                                    placeholder="Type here or leave empty"
                                    onChange={(e) =>
                                        handleChangeStateInput(
                                            item.id,
                                            0,
                                            `then`,
                                            e.target.value
                                        )
                                    }
                                    value={item.then}
                                />
                            )}
                        </div>
                    </div>
                ) : null}

                {/* ELSE START */}

                {item.type === 'else' ? (
                    <div>
                        {/* <div className="condition-name">Then</div> */}
                        <div className="transform-conditional-card">
                            <div>
                                <div
                                    onClick={() => {
                                        handleShowListBox(`${item.id}_8`);
                                    }}
                                    className="select-box-grey"
                                >
                                    <div className="title-var-left">
                                        {item.then_type}
                                    </div>
                                    <div>
                                        <img
                                            className="icon-arrow-down"
                                            src={icon_arrow_down_light}
                                        />
                                    </div>
                                </div>
                                <div
                                    className={
                                        showListBox === `${item.id}_8`
                                            ? 'select-list-box-grey'
                                            : 'd-none'
                                    }
                                >
                                    <ul>
                                        <li
                                            onClick={() =>
                                                handleChangeState(
                                                    item.id,
                                                    0,
                                                    `then`,
                                                    'Column',
                                                    ''
                                                )
                                            }
                                        >
                                            Column
                                        </li>
                                        <li
                                            onClick={() =>
                                                handleChangeState(
                                                    item.id,
                                                    0,
                                                    `then`,
                                                    'Value',
                                                    ''
                                                )
                                            }
                                        >
                                            Value
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            {item.then_type === 'Column' ? (
                                <>
                                    <div
                                        onClick={() => {
                                            handleShowListBox(`${item.id}_9`);
                                        }}
                                        className="select-box-white"
                                    >
                                        <div className="title-var-right">
                                            {item.then
                                                ? tableColumnByIndex[item.then]
                                                      .columnName
                                                : null}
                                        </div>
                                        <div>
                                            <img
                                                className="icon-arrow-down"
                                                src={icon_arrow_down_light}
                                            />
                                        </div>
                                    </div>
                                    <div
                                        className={
                                            showListBox === `${item.id}_9`
                                                ? 'select-list-box-white'
                                                : 'd-none'
                                        }
                                    >
                                        <ul
                                            onClick={() => {
                                                handleShowListBox(
                                                    `${item.id}_9`
                                                );
                                            }}
                                        >
                                            {availableColumnListThen}
                                        </ul>
                                    </div>
                                </>
                            ) : (
                                <input
                                    className="input-box-white"
                                    placeholder="Type here"
                                    onChange={(e) =>
                                        handleChangeStateInput(
                                            item.id,
                                            0,
                                            `then`,
                                            e.target.value
                                        )
                                    }
                                    value={item.then}
                                />
                            )}
                        </div>
                    </div>
                ) : null}

                {/* {props.conditionalItems[props.conditionalItems.length - 1]
                    .type !== 'else' ? (
                    <div className="add-condition-container">
                        <div
                            className="transform-conditional-card-add"
                            onClick={() => {
                                handleAddElseIf();
                            }}
                        >
                            <img src={icon_add_conditional} />
                            <div className="add-condition">Else if</div>
                        </div>
                        <div
                            className="transform-conditional-card-add"
                            onClick={() => {
                                handleAddElse();
                            }}
                        >
                            <img src={icon_add_conditional} />
                            <div className="add-condition">Else</div>
                        </div>
                    </div>
                ) : null} */}
            </div>
            // </div>
        );
    });

    // console.log(
    //     'rawProjectData',
    //     props.rawProjectData.data.schema.fields[9].contitional_transform
    // );

    return (
        <>
            <div className="transform-container-box" ref={ref}>
                {itemListsObject}

                {props.conditionalItems[props.conditionalItems.length - 1]
                    .type !== 'else' ? (
                    <div className="add-condition-container">
                        <div
                            className="transform-conditional-card-add"
                            onClick={() => {
                                handleAddElseIf();
                            }}
                        >
                            <img src={icon_add_conditional} />
                            <div className="add-condition">Else if</div>
                        </div>
                        <div
                            className="transform-conditional-card-add"
                            onClick={() => {
                                handleAddElse();
                            }}
                        >
                            <img src={icon_add_conditional} />
                            <div className="add-condition">Else</div>
                        </div>
                    </div>
                ) : null}

                <div className="transform-conditional-card-buttons">
                    <div
                        className="button-clear-all"
                        onClick={() => {
                            handleBtnClearAll();
                        }}
                    >
                        CLEAR ALL
                    </div>

                    {props.columnDbId === null ? (
                        <div
                            className="button-create"
                            onClick={() => {
                                handleBtnCreate();
                            }}
                        >
                            CREATE
                        </div>
                    ) : loadingSpinner ? (
                        <>
                            <div className="button-create">
                                UPDATE <div className="lds-dual-ring"></div>
                            </div>
                        </>
                    ) : (
                        <>
                            <div
                                className="button-create"
                                onClick={() => {
                                    handleBtnCreate(props.columnDbId);
                                }}
                            >
                                UPDATE
                            </div>
                        </>
                    )}
                </div>
            </div>
        </>
    );
};

export default TransformConditional;
